<template>
  <div class="radio-button-simples">
    <label>{{ titulo }}:</label>
    <button :class="ativo == true ? 'ativo' : ''" @click="switchEstado(true)">
      <span></span>
      <p>Sim</p>
    </button>
    <button :class="ativo == false ? 'ativo' : ''" @click="switchEstado(false)">
      <span></span>
      <p>Não</p>
    </button>
  </div>
</template>

<script>
export default {
  name: 'radioButtonSimples',

  props: {
    titulo: {
      type: String,
      required: true,
    },
    value: Boolean,
    enabled: Boolean,
    disabled: Boolean,
  },

  data() {
    return {
      ativo: undefined,
    };
  },
  created() {
    if (this.enabled) {
      this.switchEstado(true);
    } else if (this.disabled) {
      this.switchEstado(false);
    }
  },
  methods: {
    switchEstado(estado) {
      this.ativo = estado;
      this.$emit('change', estado);
    },
  },
  watch: {
    value: function(newValue) {
      this.switchEstado(newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.radio-button-simples {
  display: inline-flex;
  align-items: center;
  margin-right: 40px;
  margin-bottom: 10px;

  & label {
    color: white;
    font-family: 'OpenSans';
    font-size: 13px;
    font-weight: 600;
    margin-right: 10px;
  }

  & button {
    font-family: 'OpenSans';
    display: flex;
    flex-direction: row;
    align-items: center;
    background: none;
    outline: none;
    border: 0px;
    padding: 0px;
    margin: 0px;
    margin-right: 10px;

    & span {
      display: block;
      width: 12px;
      height: 12px;
      border-radius: 20px;
      border: 1px solid white;
      opacity: 0.35;
      margin-right: 5px;
      transition: all 0.2s ease-in-out;
    }

    & p {
      font-size: 13px;
      color: white;
      opacity: 0.35;
      margin: 8px 0px;
      margin-right: 1px;
    }
  }

  & .ativo {
    & span {
      background: $cor_amarelo;
      border: 1px solid $cor_amarelo;
      opacity: 1;
    }

    & p {
      font-weight: bold;
      color: $cor_amarelo;
      opacity: 1;
      margin-right: 0px;
    }
  }

  & .nao {
    & span {
      background: white;
    }
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .radio-button-simples {
    margin-right: 0px;
    margin-bottom: 5px;

    & label {
      font-size: 12px;
    }

    & button {
      margin-right: 5px;

      & span {
        width: 10px;
        height: 10px;
        border-radius: 20px;
      }

      & p {
        font-size: 11px;
        margin: 8px 0px;
      }
    }

    & .ativo {
      & span {
        background: $cor_amarelo;
        border: 1px solid $cor_amarelo;
        opacity: 1;
      }

      & p {
        font-weight: bold;
        color: $cor_amarelo;
        opacity: 1;
        margin-right: 0px;
      }
    }

    & .nao {
      & span {
        background: white;
      }
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .radio-button-simples {
    margin-right: 30px;
  }
}
</style>
